<template>
  <section class="categories" aria-labelledby="categories-title">
    <h2 id="categories-title" class="sr-only">Shop by category</h2>
    <router-link
      v-for="(cat, i) in categories"
      :key="cat.handle"
      :to="`/collections/${cat.handle}`"
      class="category-tile"
    >
      <div class="category-tile__media">
        <img v-if="cat.image" :src="cat.image" :alt="cat.title" />
        <PlaceholderArt v-else :label="cat.title" :tone="i + 1" />
      </div>
      <div class="category-tile__caption">
        <h3>{{ cat.title }}</h3>
        <span class="category-tile__cta">Shop {{ cat.title.toLowerCase() }} →</span>
      </div>
    </router-link>
  </section>
</template>

<script>
import { fetchCollection } from '../../shopify/products'
import PlaceholderArt from '../PlaceholderArt.vue'

export default {
  name: 'CategoryTiles',

  components: { PlaceholderArt },

  data() {
    return {
      // Each tile shows its collection's newest product; placeholder art
      // until the collection exists in Shopify and has a product in it.
      categories: [
        { handle: 'paintings', title: 'Paintings', image: null },
        { handle: 'ceramics', title: 'Ceramics', image: null },
        { handle: 'rugs', title: 'Rugs', image: null },
      ],
    }
  },

  mounted() {
    this.categories.forEach(async (cat) => {
      try {
        const collection = await fetchCollection(cat.handle, 1)
        const url = collection?.products[0]?.image
        // Shopify's CDN resizes on the fly via the width param.
        if (url) cat.image = `${url}${url.includes('?') ? '&' : '?'}width=900`
      } catch {
        // Keep the placeholder if Shopify is unreachable.
      }
    })
  },
}
</script>

<style scoped>
.categories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.4rem;
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 8rem 4rem;
}

.category-tile {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  color: var(--ink);
}

.category-tile__media {
  aspect-ratio: 4 / 5;
  overflow: hidden;
}

.category-tile__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.category-tile__caption {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1.6rem;
}

.category-tile__caption h3 {
  font-size: 3rem;
  font-weight: 400;
  transition: color 0.25s ease;
}

.category-tile__cta {
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--stone);
  transition: color 0.15s;
}

.category-tile:hover h3 { color: var(--amber); }
.category-tile:hover .category-tile__cta { color: var(--amber); }

@media (max-width: 960px) {
  .categories { gap: 1.2rem; padding: 4.8rem 1.6rem; }
  .category-tile__caption { flex-direction: column; gap: 0.4rem; }
  .category-tile__caption h3 { font-size: 2.4rem; }
}

@media (max-width: 640px) {
  .categories { grid-template-columns: 1fr; gap: 3.2rem; }
  .category-tile__media { aspect-ratio: 4 / 3; }
}
</style>
